module.exports = _.isPlainObject;